import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
import { Controller } from "react-hook-form";
import { useState } from "react";
import { Button } from "primereact/button";

interface IDate {
    label?: string;
    name: string;
    defaultValue?: string | number | Date;
    control: any;
    error?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    column?: number;
    maxDate?: Date;
    minDate?: Date;
    type?: string;
    showTime?: boolean;
}

export const JVDate = (props: IDate) => {
    const className = props.column
        ? `field col-12 md:col-${12 / props.column}`
        : "field col-12 md:col-6";
    const type = props.type ? props.type : "date";

    const [visible, setVisible] = useState(false);

    return (
        <div className={className}>
            {props.label && (
                <label htmlFor={props.name}>
                    {props.label}
                    {props.required && <span style={{ color: "red" }}>*</span>}
                </label>
            )}

            <Controller
                name={props.name}
                control={props.control}
                defaultValue={props.defaultValue ?? ""}
                render={({ field, fieldState }) => (
                    <Calendar
                        {...field}
                        view={type}
                        disabled={props.disabled}
                        className={classNames({ "p-invalid": fieldState.invalid })}
                        placeholder={props.placeholder}
                        minDate={props.minDate}
                        maxDate={props.maxDate}
                        showButtonBar
                        dateFormat={
                            type === "date"
                                ? "dd/mm/yy"
                                : type === "year"
                                ? "yy"
                                : type === "month"
                                ? "mm"
                                : "dd/mm/yy"
                        }
                        showTime={props.showTime}
                        hourFormat="12"
                        showIcon
                        visible={visible}
                        onVisibleChange={(e) => setVisible(e.visible)}
                        footerTemplate={() => (
                            <div className="flex justify-end p-2 border-t">
                                <Button
                                    icon="pi pi-times"
                                    className="p-button-rounded p-button-text p-button-sm"
                                    onClick={() => setVisible(false)}
                                    type="button"
                                    tooltip="Close"
                                />
                            </div>
                        )}
                    />
                )}
            />

            <small className="p-error">{props.error}</small>
        </div>
    );
};
